import { cloneElement } from "react";
import { PERMISSIONS } from "../../../../auth/permissions";
import { ContentBase } from "../ContentBase";
import { GenerateElementProps } from "../IContent";

export class IconContent extends ContentBase {
  constructor(
    private icon: JSX.Element,
    styles = "",
    permissions: PERMISSIONS[] = [],
    condition = () => true,
  ) {
    super(styles, permissions, condition);
  }

  protected generateContentElement(props: GenerateElementProps): JSX.Element {
    return cloneElement(this.icon, {
      className: "h-5 w-5 " + this.styles,
      "data-cy": this.testAttribute,
    });
  }

  clone(): IconContent {
    return new IconContent(
      this.icon,
      this.styles,
      this.permissions,
      this.condition,
    );
  }
}
